'use strict';

import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import {
  matchTextToTerm,
  sortItems
} from 'helpers/matchers';

import {
  autocompleteListItemClassName,
  autocompleteListItemStyle
} from 'helpers/classNameStyles';
import Autocomplete from 'components/clarity-ui/inputs/autocomplete';
import SectionHeader from 'components/clarity-ui/components/sectionHeader';
import Loader from 'components/clarity-ui/components/loader';
import LabelViewerPageHeader from './labelViewerPageHeader.component';
import LabelList from './details/labelList';
import LabelOverviewComponent from './details/labelOverview.component';
import LabelParentsTable from './details/labelParentsTable.component';
import labelsSelector from './label.selector';
import _ from 'lodash';


class LabelViewerComponent extends React.Component {

  constructor () {
    super();
    this.handleFilterLabelsAutocompleteChange = _.debounce(this.handleFilterLabelsAutocompleteChange, 1000);
  }

  componentWillMount () {
    var loading = false;
    if (!!this.props.labelDetails) {
      const labelId = this.props.labelDetails.id;
      const parentId = !!this.props.labelsTree && !!this.props.labelsTree.parentLabel ?
                  (!!this.props.labelsTree.parentLabel.id ?
                    this.props.labelsTree.parentLabel.id : this.props.labelsTree.parentLabel.parentLabel.id) :
                  0;
      const paramParentId = !!this.props.urlLabelChecker &&
                    this.props.urlLabelChecker !== parentId ? this.props.urlLabelChecker : parentId;

      browserHistory.push(`/labelViewer/${labelId}/${paramParentId}`);
    } else {
      loading = true;
      this.props.fetchTier1Labels();
    }
    this.setState({filterLabelsAutocomplete: {id: 0, value: ''}, loading: loading});
  }

  componentDidUpdate (prevProps, prevState) {
    const newState = {};
    const { labelDetails } = this.props;
    const prevLabelDetails = prevProps.labelDetails;
    const { filterLabelsAutocomplete, loading } = this.state;

    if (!!labelDetails && !this.isLabelDetailValid(labelDetails) && prevProps.labelDetails !== labelDetails) {
      this.goToLabelViewerMain();
    }
    _.assign(newState, this.shouldUpdateFilterLabelsAutocompleteState (labelDetails, prevLabelDetails, filterLabelsAutocomplete));
    if (prevState.loading && loading && _.isEqual(prevState, this.state)) {
      _.assign(newState, {loading: false});
    }
    if (!loading && !_.isEqual(this.props.urlLabelChecker, prevProps.urlLabelChecker)) _.assign(newState, {loading: true});

    if (!_.isEmpty(newState)) this.setState(newState);
  }

  goToLabelViewerMain () {
    browserHistory.push(`/labelViewer`);
    this.context.router.push('/labelViewer');
  }

  shouldUpdateFilterLabelsAutocompleteState (labelDetails, prevLabelDetails, filterLabelsAutocomplete) {
    const hasLabelDetails = !_.isEmpty(labelDetails);
    const hasLabelDetailChanged = !!labelDetails && !!prevLabelDetails && labelDetails.id !== prevLabelDetails.id;

    if ((hasLabelDetails && hasLabelDetailChanged &&
          labelDetails.id !== filterLabelsAutocomplete.id) || (labelDetails === null && prevLabelDetails !== null)) {
      return {filterLabelsAutocomplete: {id: 0, value: ''}};
    } else return {};
  }

  setFilterLabelsAutocompleteState (id, value) {
    this.setState({filterLabelsAutocomplete: {id: id, value: value}});
  }

  handleFilterLabelsAutocompleteChange (event, value) {
    this.setFilterLabelsAutocompleteState(0, value);
    this.props.fetchLabelsByName(value);
  }

  handleFilterLabelsAutocompleteSelect (value, item) {
    const parentId = item.parentLabel ? item.parentLabel.id : 0;
    this.context.router.push(`/labelViewer/${item.id}/${parentId}`);
    this.setFilterLabelsAutocompleteState(0, '');
  }

  renderFilteredLabelsAutocomplete () {
    return (
      <Autocomplete
        inputProps={{className:'InputField-input'}, {placeholder:'Type to Filter Labels'}}
        value={this.state.filterLabelsAutocomplete.value}
        onSelect={this.handleFilterLabelsAutocompleteSelect.bind(this)}
        onChange={this.handleFilterLabelsAutocompleteChange.bind(this)}
        items={this.props.filteredLabels}
        getItemValue={(label) => label.name}
        shouldItemRender={matchTextToTerm}
        sortItems={sortItems}
        shouldClear={false}
        renderItem={(label, isHighlighted, styles) => (
          <li
            className={autocompleteListItemClassName(isHighlighted)}
            style={autocompleteListItemStyle(isHighlighted, styles)}
            key={label.id}
          >{label.name}</li>
        )}
      />
    );
  }

  handleSelectedRoute (labelId, parentLabel) {
    const parentId = !!parentLabel ? parentLabel.id : 0;
    const paramParentId = !!this.props.urlLabelChecker &&
                  this.props.urlLabelChecker !== parentId ? this.props.urlLabelChecker : parentId;
    this.context.router.push(`/labelViewer/${labelId}/${paramParentId}`);
    this.setState({loading: true});
  }

  handleSelect (value, item) {
    this.handleSelectedRoute (item.id, item.parentLabel);
  }

  renderAutocomplete () {
    return (
      <Autocomplete
        inputProps={{className:'InputField-input'}, {placeholder:'Find a label'}}
        value=''
        onSelect={this.handleSelect.bind(this)}
        items={this.props.selectedLabels}
        getItemValue={(label) => label.name}
        shouldItemRender={matchTextToTerm}
        sortItems={sortItems}
        renderItem={(label, isHighlighted, styles) => (
          <li
            className={autocompleteListItemClassName(isHighlighted)}
            style={autocompleteListItemStyle(isHighlighted, styles)}
            key={label.id}
          >{label.name}</li>
        )}
      />
    );
  }

  getPageHeaderItems (labelsTree, labelArray) {
    const { parentLabel, ...baseLabelInfo } = labelsTree;
    labelArray = !!labelArray ? labelArray : [];

    if (!!baseLabelInfo.id) labelArray.push(baseLabelInfo);

    if (parentLabel !== null) return this.getPageHeaderItems(parentLabel, labelArray);
      else return labelArray;
  }

  isLabelDetailValid (labelDetails) {
    const isValid = (labelDetails.state === 'approved' && labelDetails.isPublic && labelDetails.labelType !== 'flip');
    return isValid;
  }

  render () {
    const { labelsTree, selectedLabels, urlLabelChecker } = this.props;
    const breadcrumbItems = !!labelsTree ? this.getPageHeaderItems(this.props.labelsTree) : [];
    const isLabelDetailAvailable = !!this.props.labelDetails && this.isLabelDetailValid(this.props.labelDetails);
    const labelDetails = isLabelDetailAvailable ? this.props.labelDetails : {parentLabels: []},
          { id, name, parentLabels } = labelDetails;

    return (
      <div className="EntityList">
        <Loader loading={this.state.loading} />
        <div>
          <LabelViewerPageHeader title="Label Viewer" breadcrumbItems={breadcrumbItems} />
          <div className="BreakLine">
            { this.renderFilteredLabelsAutocomplete() }
          </div>
          <div className="BreakLine">
            <SectionHeader>Details</SectionHeader>
            <LabelOverviewComponent id={id} name={name}/>
          </div>
          <div className="BreakLine">
            <SectionHeader>Parents</SectionHeader>
            <LabelParentsTable parentLabels={parentLabels} />
          </div>
          <div className="BreakLine">
            <SectionHeader>Children</SectionHeader>
            { this.renderAutocomplete() }
          </div>
        </div>
        <LabelList
          urlLabelChecker={urlLabelChecker}
          selectedLabels={selectedLabels}
          handleSelectedRoute={this.handleSelectedRoute.bind(this)}
        />
      </div>
    );
  }
}

const mapStateToProps = () => {
  const getLabelList = labelsSelector;
  const stateToProps = (state) => {
    return getLabelList(state);
  };
  return stateToProps;
}

LabelViewerComponent.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default connect(mapStateToProps)(LabelViewerComponent);



// WEBPACK FOOTER //
// ./src/components/labelViewer/labelViewer.component.jsx